import {ELicenseStatus} from './definitions';

export default {
  licenses: 'Licenses and connected tariff plans',
  termsValidUntil: 'The user agreement is valid until:',
  accordingToTerms: 'According to the terms of the agreement',
  termsAccepted: 'The user agreement has been accepted on',
  licenseStatus: {
    [ELicenseStatus.NEW]: 'Attention required',
    [ELicenseStatus.CANCELLED]: 'Inactive',
    [ELicenseStatus.ACTIVE]: 'Active',
    [ELicenseStatus.ACTIVE_DEBT]: 'Attention required',
    [ELicenseStatus.EXPIRED]: 'Expired',
    [ELicenseStatus.TEMPORARY_BLOCKED]: 'Temporary blocked',
  },
  noTariffs: {
    title: "Let's connect the tariff",
    subtitle: 'Contact your manager to open the available tariffs for this channel',
    action: 'Contact manager',
  },
  whatsAppMauInfo: '{{count}} out of {{tariffCount}}',
  createdAt: 'Created ',
  cancelledAt: 'Cancelled ',
  validUntil: 'Valid until ',
  expiredAt: 'Expired on ',
  temporaryblockedAt: 'Temporarily blocked from ',
  validUntilHint: 'Activated on {{activatedAt}}; paid until {{paidUntil}}',
  scheduledCancel: 'Deactivation scheduled',
  showAll: 'Show all',
  hide: 'Hide all',
  button: {
    block: 'Discontinue',
    refuse: 'Discontinue',
    cancel: 'Cancel',
  },
  header: {
    name: 'License name',
    tariff: 'License Tariff Plan',
    subject: 'Sender',
    status: 'Status',
    whatsAppMau: 'Remaining MAU for your tariff',
    whatsAppAmau: 'AMAU used',
    whatsAppAmauHint:
      'AMAU (Additional Monthly Active Users) is the number of unique recipients above your plan limit who interacted with you in the current month',
    duration: 'License validity period',
  },
  licensesInformation: {
    licenses: 'Licenses:',
    status: {
      [ELicenseStatus.ACTIVE]: '{{count}} active',
      [ELicenseStatus.EXPIRED]: '{{count}} expired',
      [ELicenseStatus.CANCELLED]: '{{count}} inactive',
      [ELicenseStatus.TEMPORARY_BLOCKED]: '{{count}} temporary blocked',
    },
    needAttention: '{{count}} attention required',
  },
  tariffModal: {
    title: 'Tariff {{name}}',
    tariff: 'Tariff:',
    channel: 'Channel:',
    activeFrom: 'Activation date:',
    willChange: 'Will change {{date}}',
  },

  options: {
    edit: 'Change date',
    cancel: 'Cancel',
  },
  confirmModal: {
    title: 'Planning for the early license deactivation',
    description:
      "You have selected a deactivation date of {{date}} before the license's expiry date. Are you sure you want to deactivate the license on this date?",
  },
  cancelModal: {
    title: "Schedule the deactivation of a customer's license?",
    description:
      'Once deactivated, the license will be permanently blocked and cannot be restored. It will no longer be possible to send or receive messages via this channel',
    hint: 'On the date of the scheduled deactivation, the license will be suspended at 11:59:00 p.m.',
    selectDate: 'Select deactivation date',
    successBlock: 'Deactivation has been planned',
  },
  confirmCancelModal: {
    title: 'Cancel license deactivation?',
    description: 'The license scheduled for deactivation will remain in its current status',
    button: 'Cancel',
    successCancel: 'License deactivation has been successfully revoked',
  },
  changeModal: {
    title: 'Change license deactivation date?',
    description:
      'Once deactivated, the license will be permanently blocked and cannot be restored. It will no longer be possible to send or receive messages via this channel',
    scheduledDate: 'Scheduled deactivation date',
    newDate: 'New deactivation date',
    hint: 'On the date of the scheduled deactivation, the license will be suspended at 11:59:00 p.m.',
  },
};
